export default "__VITE_ASSET__810c7986__"